<template>
    <div class="product-details__content">
        <div id="qna" class="product-qna-container" data-tab-contents="qna">
            <div class="product-qna__head">
                <div class="product-qna__form">
                    <div class="product-qna__form-inner" action="">
                        <div class="product-qna__search">
                            <input v-model="filter.searchValue" class="input" type="text" name="" value="">
                            <button class="button" @click="page = 1; search();"></button>
                        </div>
                        <select v-model="filter.type" class="product-qna__select" name="">
                            <option :value="null" disabled selected>항목을 선택해주세요.</option>
                            <option value="상품">상품</option>
                            <option value="배송">배송</option>
                            <option value="기타">기타</option>
                        </select>
                    </div>
                </div>
                <div class="product-qna__buttons">
                    <div @click="$emit('openModal')" class="button button--border-orange">문의하기</div>
                </div>
            </div>
            <div class="product-qna__body">
                <div role="table" class="board-table board-table--inquiry">
                    <div role="rowgroup">
                        <div role="row">
                            <div role="columnheader" class="num">번호</div>
                            <div role="columnheader" class="title">문의사항</div>
                            <div role="columnheader" class="cell">문의유형</div>
                            <div role="columnheader" class="cell">답변상태</div>
                            <div role="columnheader" class="cell">작성자</div>
                            <div role="columnheader" class="cell">작성일</div>
                        </div>
                    </div>
                    <div v-for="(inquire, index) in inquires" :key="inquire._id">
                        <div role="rowgroup" @click="$set(inquire, 'on', !inquire.on)">
                            <div role="row">
                                <div role="cell" class="num">{{ (page - 1) * limit + (+index + 1) }}</div>
                                <div role="cell" class="title">
                                    <div class="title">
                                        <a role="button" data-idx="5">
                                            <span v-if="!inquire.secret || inquire._user == payload._user">{{ inquire.subject }}</span>
                                            <span v-else>비밀글입니다</span>
                                        </a>
                                    </div>
                                </div>
                                <div role="cell" class="cell type">
                                    <span>{{ inquire.type }}</span>
                                </div>
                                <div role="cell" class="cell state">
                                    <span v-if="inquire.reply">답변완료</span>
                                    <span v-else>미답변</span>
                                </div>
                                <div role="cell" class="cell writer">
                                    <span v-if="inquire.user">
                                        {{ inquire.user.name.replace(/(.).(.+)/, "$1*$2") }}
                                    </span>
                                    <span v-else>탈퇴회원</span>
                                </div>
                                <div role="cell" class="cell date"><span class="date">{{ inquire.createDate.toDate() }}</span></div>
                            </div>
                        </div>
                        <div v-if="!inquire.secret || inquire._user == payload._user" role="rowgroup" class="answer" data-idx-answer="5" :data-answer="inquire.on ? 'opened' : ''">
                            <div role="row">
                                <div role="cell" class="num"></div>
                                <div role="cell" class="question">
                                    <div class="question" v-html="inquire.content.replace(/\n/g, '<br>')"></div>
                                    <div v-if="inquire.images && inquire.images.filter(image => image)">
                                        <div v-for="(image, index) in inquire.images" :key="index" :style="{ background: `url('${image}')`}"></div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="inquire.reply" role="row" class="background">
                                <div role="cell" class="num"><span class="symbol"></span></div>
                                <div role="cell" class="answer">
                                    <div class="answer" v-html="inquire.reply.replace(/\n/g, '<br>')"></div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
import api from "@/api";

export default {
    props: {
        product: { type: Object, default: null },
    },
    data() {
        return {
            filter: {
                _product: this.$props.product._id,
                searchKey: "subject",
                searchValue: null,
                type: null
            },

            page: 1,
            pageCount: 0,
            limit: 10,

            inquires: []
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init(){
            await this.search();
        },

        async search(){
            try{
                var { inquires } = await api.v1.shop.inquires.getInquires({
                    headers: {
                        skip: (this.page - 1) * this.limit,
                        limit: this.limit
                    },
                    params: this.filter
                });
                this.inquires = inquires;
            }
            catch(error){
                console.error(error);
                alert(error.response ? error.response.data.message : error.message );
            }
        },
    },
    computed: {
        payload(){
            return this.$store.state.payload;
        }
    }
}
</script>
